import { MetricRow } from '../rows/MetricRow'
import { FactOnlyRow } from '../rows/FactOnlyRow'
import { ConversionRow } from '../rows/ConversionRow'
import { AverageCheckRow } from '../rows/AverageCheckRow'
import type { MonthMetrics } from '@/features/history/types'

interface SalesSectionProps {
  metrics: MonthMetrics
  weeklyAvg: (v: number) => number
  formatNumber: (v: number) => string
  formatCurrency: (v: number) => string
  formatConversion: (from: number, to: number) => string
  hasRegularSalesData: boolean
  hasNewSalesCountData: boolean
  hasNewSalesAmountData: boolean
  hasNewSalesAvgCheckData: boolean
  hasTrialPaymentsData: boolean
  hasSubscriptionSalesData: boolean
  hasNewSubscriptionsCountData: boolean
  hasNewSubscriptionsAmountData: boolean
  hasNewSubscriptionsAvgCheckData: boolean
  hasMembershipFeesNewData: boolean
}

export function SalesSection({
  metrics,
  weeklyAvg,
  formatNumber,
  formatCurrency,
  formatConversion,
  hasRegularSalesData,
  hasNewSalesCountData,
  hasNewSalesAmountData,
  hasNewSalesAvgCheckData,
  hasTrialPaymentsData,
  hasSubscriptionSalesData,
  hasNewSubscriptionsCountData,
  hasNewSubscriptionsAmountData,
  hasNewSubscriptionsAvgCheckData,
  hasMembershipFeesNewData,
}: SalesSectionProps) {
  const { new_visitors_count: visitors, new_sales_count: salesCount, new_sales_amount: salesAmt,
    new_sales_avg_check: salesAvg, trial_payments: trial,
    new_subscriptions_count: subCount, new_subscriptions_amount: subAmt,
    new_subscriptions_avg_check: subAvg, membership_fees_new: mfNew } = metrics

  return (
    <>
      {hasRegularSalesData && (
        <>
          {hasNewSalesCountData && (
            <>
              <MetricRow
                label="Новые продажи (кол-во)"
                metric={salesCount}
                weeklyPlan={weeklyAvg(salesCount.plan)}
                weeklyFact={weeklyAvg(salesCount.fact)}
                formatPlan={formatNumber}
                formatFact={formatNumber}
              />
              <ConversionRow
                label="Конверсия Приходы → Продажи"
                planConversion={formatConversion(visitors.plan, salesCount.plan)}
                factConversion={formatConversion(visitors.fact, salesCount.fact)}
              />
            </>
          )}
          {hasNewSalesAmountData && (
            <MetricRow
              label="Новые продажи (сумма)"
              metric={salesAmt}
              weeklyPlan={weeklyAvg(salesAmt.plan)}
              weeklyFact={weeklyAvg(salesAmt.fact)}
              formatPlan={formatCurrency}
              formatFact={formatCurrency}
            />
          )}
          {hasNewSalesAvgCheckData && <AverageCheckRow label="Средний чек" metric={salesAvg} formatValue={formatCurrency} />}
          {hasTrialPaymentsData && (
            <FactOnlyRow
              label="Оплаты пробного (факт)"
              weeklyFact={formatCurrency(weeklyAvg(trial.fact))}
              monthFact={formatCurrency(trial.fact)}
            />
          )}
        </>
      )}

      {hasSubscriptionSalesData && (
        <>
          {hasNewSubscriptionsCountData && (
            <>
              <MetricRow
                label="Новые подписки (кол-во)"
                metric={subCount}
                weeklyPlan={weeklyAvg(subCount.plan)}
                weeklyFact={weeklyAvg(subCount.fact)}
                formatPlan={formatNumber}
                formatFact={formatNumber}
              />
              <ConversionRow
                label="Конверсия Приходы → Подписки"
                planConversion={formatConversion(visitors.plan, subCount.plan)}
                factConversion={formatConversion(visitors.fact, subCount.fact)}
              />
            </>
          )}
          {hasNewSubscriptionsAmountData && (
            <MetricRow
              label="Новые подписки (сумма)"
              metric={subAmt}
              weeklyPlan={weeklyAvg(subAmt.plan)}
              weeklyFact={weeklyAvg(subAmt.fact)}
              formatPlan={formatCurrency}
              formatFact={formatCurrency}
            />
          )}
          {hasNewSubscriptionsAvgCheckData && <AverageCheckRow label="Средний чек" metric={subAvg} formatValue={formatCurrency} />}
          {hasMembershipFeesNewData && (
            <MetricRow
              label="Членские взносы новых"
              metric={mfNew}
              weeklyPlan={weeklyAvg(mfNew.plan)}
              weeklyFact={weeklyAvg(mfNew.fact)}
              formatPlan={formatCurrency}
              formatFact={formatCurrency}
            />
          )}
        </>
      )}
    </>
  )
}
